import { useTranslation } from "next-i18next";
import { FC, useState, useEffect } from "react";
import classes from "./ReadMore.module.scss";

export interface ReadMoreProps {
  minLength?: number;
  children: string;
  readMore?: string;
  readLess?: string;
  isActive?: boolean;
  toggleReadMore?: any;
}

const ReadMore: FC<ReadMoreProps> = ({
  readMore,
  readLess,
  minLength,
  children,
  isActive,
  toggleReadMore,
}) => {
  const [filteredText, setFilteredText] = useState("");

  const { t } = useTranslation("common");

  const text =
    isActive && children?.length > minLength!
      ? `${children?.slice(0, minLength! - 3)}...`
      : children;

  useEffect(() => {
    const textFiltered = text?.replace(/<[^>]*>/g, " ");
    setFilteredText(textFiltered);
  }, [text]);

  return (
    <p>
      {isActive ? (
        <span
          className={classes["description-text"]}
          dangerouslySetInnerHTML={{ __html: filteredText }}
        ></span>
      ) : (
        <span
          className={classes["description-text"]}
          dangerouslySetInnerHTML={{ __html: text }}
        ></span>
      )}

      {children?.length > minLength! ? (
        <span onClick={toggleReadMore} className={classes["read-or-hide"]}>
          &nbsp;
          {isActive
            ? readMore
              ? readMore
              : t("general.accessibility.read_more")
            : readLess
            ? readLess
            : t("general.accessibility.read_less")}
        </span>
      ) : (
        <></>
      )}
    </p>
  );
};

ReadMore.defaultProps = {
  minLength: 100,
  readLess: "",
  readMore: "",
  isActive: true,
  toggleReadMore: false,
};

export default ReadMore;
